import axiosInstance from '../../utils/axiosConfig';

export async function getReparationMissionDecisionMotif() {
    try {
   
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/reparationMissionDecisionMotif/getAll`;
      const response = await axiosInstance.get(url); 
      return response.data;
    } catch (error) {
      console.error(`Error fetching reparation Mission Decision Motif details: ${error.message}`);
    }
  }

  export const GET_ALL_SERVICE_TYPE_SUCCESS = 'GET_ALL_SERVICE_TYPE_SUCCESS';

  export const getAllServiceType = () => async (dispatch) => {
      try {
          const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/service/getAll`;
          const response = await axiosInstance.get(url);
          dispatch({
              type: GET_ALL_SERVICE_TYPE_SUCCESS,
              payload: response.data,
          });
      } catch (error) {
          console.error(`Error fetching list of services: ${error.message}`);
      }
  };
  

// export async function getAllMotifs() {
//     try {
//         const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/serviceProposalDecisionMotif/getAll`;
//         const response = await axiosInstance.get(url);
//         return response.data;
//     } catch (error) {
//         console.error(`Error fetching list of motifs: ${error.message}`);
//     }
// }
export const getAllMotifs = () => {
    return async (dispatch) => {
        try {
            const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/serviceProposalDecisionMotif/getAll`;
            const response = await axiosInstance.get(url);
            dispatch({
                type: 'GET_ALL_MOTIFS_SUCCESS',
                payload: response.data,
            });
            return response.data
        } catch (error) {
            console.error(`Error fetching list of motifs: ${error.message}`);
            dispatch({
                type: 'GET_ALL_MOTIFS_FAILURE',
                payload: error.message,
            });
        }
    };
};

export async function getSubMotifsByMotif(motifId) {
    try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/serviceProposalDecisionSubMotif/getAll`;
        const response = await axiosInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(`Error fetching sub-motifs for motif ${motifId}: ${error.message}`);
    }
}

export const updateReparationMission = async (reparationMissionId, repartitionObject) => {
  try {
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/reparationMission/update/${reparationMissionId}`;
      const response = await axiosInstance.put(url, repartitionObject);
      return response.data ;
  } catch (error) {
      console.error(error.message);
      return { success: false, error: error.message };
  }
};

export const updateServiceProposal = async(serviceProposalId, serviceProposalObject) => {
    try {
          const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/serviceProposal/update/${serviceProposalId}`;
          const response = await axiosInstance.put(url, serviceProposalObject);
          return response.data ;
        } catch (error) {
            console.error(error.message);
            return { success: false, error: error.message };
        }
      };

export const createFinancialDocument = (documentData) => async (dispatch) => {
    try {
        const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/financialDocument/create`, documentData);
        dispatch({
            type: 'CREATE_FINANCIAL_DOCUMENT_SUCCESS',
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: 'CREATE_FINANCIAL_DOCUMENT_FAILURE',
            payload: error.response ? error.response.data : 'Server error',
        });
    }
};

// export const createServiceProposal = (proposalData) => async (dispatch) => {
//     try {
//         const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/serviceProposal/create`, proposalData);
//         dispatch({
//             type: 'CREATE_SERVICE_PROPOSAL_SUCCESS',
//             payload: response.data,
//         });
//     } catch (error) {
//         dispatch({
//             type: 'CREATE_SERVICE_PROPOSAL_FAILURE',
//             payload: error.response ? error.response.data : 'Server error',
//         });
//     }
// };

export const createReparationMission = (mission) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/reparationMission/create`, mission);
     
        dispatch({
            type: 'CREATE_REPARATION_MISSION_SUCCESS',
            payload: response.data,
        });
        return response.data
    } catch (error) {
      dispatch({
        type: 'CREATE_MISSION_FAILURE',
        payload: error.response? error.response.data : 'Server error',
      });
    }
  };


  export const getServiceProposalById = async (idServiceProposal) => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/serviceProposal/getById/${idServiceProposal}`;
        let response = await axiosInstance.get(url); 
        return response.data;  
      } catch (error) {
        console.error(`Error getting service proposal by ID: ${error.message}`);
      }
  };


  
  export const getClaimServiceProposals = (claimNumber) => async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/serviceProposal/filtreByClaimNumber/${claimNumber}`;
      const response = await axiosInstance.get(url);
      dispatch({
        type: 'GET_SERVICE_PROPOSAL_SUCCESS',
        payload: response.data,
      });
      return response.data; // Return the data for component use
    } catch (error) {
      dispatch({
        type: 'GET_SERVICE_PROPOSAL_FAILURE',
        payload: error.response ? error.response.data : 'Server error',
      });
      throw error; // Throw error for component use
    }
  };
  
  export const getClaimReparationMissions = (claimNumber) => async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/reparationMission/filtreByClaimNumber/${claimNumber}`;
      const response = await axiosInstance.get(url);
  
      const reparationMissions = response.data;

      const updatedMissions = await Promise.all(
        reparationMissions.map(async (mission) => {
          try {
            const repairerDetailsResponse = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/organisation/GetOrganizationDetails/${mission.associatedRepairer}`);
            return {
              ...mission,
              associatedRepairer: repairerDetailsResponse.data,
            };
          } catch (error) {
            console.error(`Error fetching repairer details for ${mission.associatedRepairer}: ${error.message}`);
            return mission; 
          }
        })
      );
  
      dispatch({
        type: 'GET_REPARATION_MISSION_SUCCESS',
        payload: updatedMissions,
      });
  
      return updatedMissions; // Return the data for component use
    } catch (error) {
      dispatch({
        type: 'GET_REPARATION_MISSION_FAILURE',
        payload: error.response ? error.response.data : 'Server error',
      });
      throw error; // Throw error for component use
    }
  };

  export const getFinancialDocuments = (claimNumber) => async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/financialDocument/filtreByClaimNumber/${claimNumber}`;
      const response = await axiosInstance.get(url);
  
      dispatch({
        type: 'GET_FINANCIAL_DOCUMENTS_SUCCESS',
        payload: response.data,
      });
      return response.data; // Return the data for component use
    } catch (error) {
      dispatch({
        type: 'GET_FINANCIAL_DOCUMENTS_FAILURE',
        payload: error.response ? error.response.data : 'Server error',
      });
      throw error; // Throw error for component use
    }
  };


  export const getReplacementCarRequests = () => async (dispatch) => {
    try {
      const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/replacementCarRequest/getAll`;
      const response = await axiosInstance.get(url);
  
      dispatch({
        type: 'GET_ALLREPLACEMENT_CAR_REQUESTS',
        payload: response.data,
      });
      return response.data; // Return the data for component use
    } catch (error) {
      dispatch({
        type: 'GET_ALLREPLACEMENT_CAR_REQUESTS_ERROR',
        payload: error.response ? error.response.data : 'Server error',
      });
      throw error; // Throw error for component use
    }
  };

  export const updateReplacementCarRequest = (replacementCarRequestId, replacementCarRequest) => async (dispatch) => {
    try {
      const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/replacementCarRequest/updateReplacementCarRequest/${replacementCarRequestId}`, replacementCarRequest);
  
      dispatch({
        type: 'UPDATE_REPLACEMENT_CAR_REQUEST',
        payload: response.data,
      });
    } catch (error) {
      console.error(`Error updating replacement car request: ${error.message}`);
    }
  };

export const createReplacementCarRequest = (replacementCarData) => async (dispatch) => {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/replacementCarRequest`;
    try {
        const response = await axiosInstance.post(url, replacementCarData);
        return response.data;
    } catch (error) {
        console.error("Error sending replacement car request:", error);
        throw error;
    }
};



export async function getReparationMissionById(repartionMissionId) {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/reparationMission/getById/${repartionMissionId}`;
    const response = await axiosInstance.get(url); 
    return response.data;
  } catch (error) {
    console.error(error.message);
  }
}

export async function getReparationMissionsForClaimsAwaitingReparation() {
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/reparationMission/getReparationMissionsForClaimsAwaitingReparation`;
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error(error.message);
  }
}

export const getFinancialDocumentByAssociatedDocument = async (associatedDocument) => {
    try {
        const url = `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/financialDocument/getByAssociatedDocument/${associatedDocument}`;
        const response = await axiosInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(`Error fetching financial document: ${error.message}`);
        return null;
    }
};

export const addEventLog = async (claimNumber, textDescription, comment) => {
  const response = await axiosInstance.post(
    `${process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT}/eventLog`,
    { associatedEntity: claimNumber, textDescription, comment }
  );
  return response.data;
};
